import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Skeleton } from "antd";
import moment from "moment";

import partnersApi from "../../../apis/Partners.api";

const DashboardMembers = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);
	const [members, setMembers] = useState([]);

	useEffect(() => {
		if (user?.id) {
			getSignUpMembers();
		}
	}, [user]);

	/**
	 * 회원가입 멤버 보여주기
	 * @type {(function(): Promise<void>)|*}
	 */
	const getSignUpMembers = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 5,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};
		const res = await partnersApi.readSignUpMembers(param);
		if (res.code === 200) {
			// setMembers(res.result?.filter((item) => item.profile_img_type));
			setMembers(res.result?.userList);
		}
		setLoading(false);
	}, []);

	return (
		<div className={`dashboard-body-each`}>
			<h2 className={`dashboard-each-title`}>최근 가입자</h2>
			{members?.length ? (
				<div style={{ display: "flex", flexDirection: "column", gap: "2em" }}>
					{members?.map((item, idx) => (
						<div className={`dashboard-members-each`} key={`members-${idx}`}>
							<img
								src={
									item?.profile_img_type
										? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${item?.id}.${item?.profile_img_type}`
										: `/assets/images/channel/basic.png`
								}
								onError={({ currentTarget }) => {
									currentTarget.onerror = null; // prevents looping
									// currentTarget.style.display = "none";
									currentTarget.src = `/assets/images/channel/basic.png`;
								}}
								alt={`채널 이미지`}
								style={{
									width: "3em",
									height: "3em",
								}}
							/>
							<div style={{ display: "flex", flexDirection: "column" }}>
								<p>{item?.nickname}</p>
								<p className={`date`}>
									{moment(item?.created_at).format("YY년 M월 D일 a h시 m분")}
								</p>
							</div>
						</div>
					))}
				</div>
			) : !loading ? (
				<Row
					align={"middle"}
					style={{ width: "100%", flexDirection: "column", padding: "3em 0" }}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3.5em",
							height: "auto",
						}}
					/>
					<span
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.2em",
							fontWeight: 500,
						}}
					>
						가입자가 없습니다.
					</span>
				</Row>
			) : (
				<>
					{Array.from({ length: 3 }).map((item, idx) => (
						<Row
							align={"middle"}
							style={{ gap: "1em" }}
							wrap={false}
							key={`skeleton-members-${idx}`}
						>
							<Skeleton.Avatar active={loading} size={"large"} block={true} />
							<Skeleton.Button
								active={loading}
								size={"large"}
								block={true}
								style={{
									height: "4.5em",
									width: "100%",
								}}
							/>
						</Row>
					))}
				</>
			)}
			<Link to={"/user_manage"}>모두 보기</Link>
		</div>
	);
};

export default DashboardMembers;
